/* cSpell:disable */

import { findNodePath, isUrl, setNodes } from '@udecode/plate-common';

import { MyEditor, MyVideoEmbedElement } from '../../plateTypes';

export const video_providers = [
  {
    test_regex:
      /^.*((youtu.be)|(youtube.com)|(youtube-nocookie.com))\/((v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))?\??v?=?([^#&?]*).*/,
    url_regex:
      /(?:https?:\/\/)?(?:www\.)?(?:m\.)?(?:youtube\.com|youtu\.be|youtube-nocookie\.com)\/(?:watch\?v=|embed\/)?([0-9a-zA-Z_-]+)(.+)?/g,
    url_text: 'https://www.youtube.com/embed/$1?$2',
    provider: 'youtube' as const,
  },
  {
    test_regex:
      /^.*(?:vimeo.com)\/(?:channels(\/\w+\/)?|groups\/*\/videos\/\d+\/|video\/|)(\d+)(?:$|\/|\?)/,
    url_regex:
      /(?:https?:\/\/)?(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_-]+)?(\/[a-zA-Z0-9_-]+)?/i,
    url_text: 'https://player.vimeo.com/video/$1',
    provider: 'vimeo' as const,
  },
  {
    test_regex: /^(?:.+)loom.com\/(?:watch)?\/?([^.&/]+)\/?(?:[^_.&]+)?/,
    url_regex: /^(?:.+)loom.com\/share\/([0-9a-zA-Z_-]+)(.+)?/g,
    url_text: 'https://www.loom.com/embed/$1',
    provider: 'loom' as const,
  },
];

type Provider = (typeof video_providers)[number];
export type Providers = (typeof video_providers)[number]['provider'];

export function embedVideo({
  url,
  editor,
  element,
}: {
  url: string;
  editor: MyEditor;
  element: MyVideoEmbedElement;
}): void {
  const provider = getValidVideoProvider(url);
  if (!provider) return;
  const embedUrl = url.replace(provider.url_regex, provider.url_text);
  const path = findNodePath(editor, element);
  setNodes(
    editor,
    {
      url: embedUrl,
      provider: provider.provider,
    },
    { at: path },
  );
}

export function getValidVideoProvider(url: string | null): Provider | null {
  if (!url || !isUrl(url)) return null;
  return (
    video_providers.find((provider) => provider.test_regex.test(url)) || null
  );
}
